module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jcoQix/tc-custom/9781789559385.jpg?1716639652033",
      "alt": "This image is the cover for the book Colour of Thunder"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Colour of Thunder\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One small island, six troubled residents hunt for the truth before the storm arrives.Johnny is a powerful and successful businessman and is finally considering settling down with elusive new arrival Scarlett. However, there are whispered rumours about possible past involvement in corruption and even kidnap with his violent business partner. And the repercussions of these events are still impacting the Island’s residents.It is said many people move to Hong Kong to make a break from their past. In one of the world’s most vibrant international cities, a number of paths intertwine in the hunt for the truth as the storm of the century approaches.‘I thoroughly enjoyed reading this gripping and intriguing mystery… Not only is the story full of deep secrets and provocative characters but it also captures the many compelling and diverse facets of Hong Kong in the narrative. This captivating and dynamic book is a must for anyone who enjoys a stormy atmospheric ride set in a city rich in culture and intrigue.’ Jules Hannaford, author of Fool Me Twice, Podcaster of Hong Kong Confidential'I was utterly immersed in this complex, intriguing, vividly atmospheric tale of Hong Kong.' Charity Norman'Gripping... a sinuous mystery juggl[ing] murder, kidnapping, child trafficking, corrupt policing, assault, arson and political oppression' South China Morning Post")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Suzanne Harrison\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Legend Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0